import { IconButton, Typography } from '@mui/material';

import React from 'react';

import Box from '@mui/material/Box';

import InteractionsCTAs from 'src/components/news/InteractionsCTAs';
import type { InteractionCTAsProps } from 'src/components/news/InteractionsCTAs';
import Icon from 'src/components/ui/Icon';
import { colours } from 'src/constants/colours';
import type { Ad, NewsPost, PostsQuery } from 'src/types/__generated__/graphql';
import { styledComponent } from 'src/utils/styled';

const SmallStyledIconButton = styledComponent(IconButton)`
    width: 3rem;
    padding: 0.55rem 0.25rem;
    svg {
        margin-right: 0.1875rem;
    }
    p {
        font-size: 0.875rem;
        color: ${colours.blackOpacity.O54};
    }
`;

type NewsPostForInteractionsBar = InteractionCTAsProps['newsPost'] & Pick<NewsPost, 'totalLikes' | 'id' | 'stats'>;
interface Props {
    post?: ArrayElement<PostsQuery['posts']>;
    newsPost?: NewsPostForInteractionsBar;
    ad?: Ad;
    onCommentsClick?: (args: unknown) => void | Promise<void>;
    onLikesClick?: (args: unknown) => void | Promise<void>;
}

const InteractionsBar: React.FC<Props> = ({ post, newsPost, onCommentsClick, onLikesClick, ad }) => (
    <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
        <InteractionsCTAs {...{ ad, post, newsPost, onCommentsClick }} />
        <Box display="flex" flexDirection="row">
            {post && (
                <SmallStyledIconButton aria-label="Chat" onClick={onCommentsClick}>
                    <Icon name="Chat" size="1rem" />
                    <Typography data-target="post-comment-count" data-target-id={`post-comment-count-id-${post.id}`}>
                        {post.totalComments}
                    </Typography>
                </SmallStyledIconButton>
            )}
            {(newsPost ?? ad) && (
                <SmallStyledIconButton aria-label="Visibility-Count" data-target-id="news-post-view-count-btn" disabled>
                    <Icon name="Show" size="1rem" color={colours.black.O38} />
                    <Typography
                        data-target={newsPost ? 'news-post-view-count' : 'ad-view-count'}
                        data-target-id={
                            newsPost ? `news-post-view-count-id-${newsPost.id}` : `ad-view-count-id-${ad?.id}`
                        }
                    >
                        {newsPost?.stats.viewCount ?? ad?.stats.viewCount ?? 0}
                    </Typography>
                </SmallStyledIconButton>
            )}
            {ad && (
                <SmallStyledIconButton aria-label="Favorites-Count">
                    <Icon name="BookmarkGrey" size="1rem" color={colours.black.O38} />
                    <Typography data-target-id="ad-favorite-count">{ad.stats.favoriteCount}</Typography>
                </SmallStyledIconButton>
            )}
            {!ad && (
                <SmallStyledIconButton
                    aria-label="Heart-Count"
                    data-target-id="like-count-btn"
                    onClick={onLikesClick}
                    disabled={post?.totalLikes === 0 || newsPost?.totalLikes === 0}
                >
                    <Icon name="HeartFillGrey" size="1rem" />
                    <Typography
                        data-target={post ? 'post-like-count' : 'news-post-like-count'}
                        data-target-id={
                            post ? `post-like-count-id-${post.id}` : `news-post-like-count-id-${newsPost?.id}`
                        }
                    >
                        {post?.totalLikes ?? newsPost?.totalLikes}
                    </Typography>
                </SmallStyledIconButton>
            )}
        </Box>
    </Box>
);

export default InteractionsBar;
